import React, { createContext, useState, useContext, useEffect } from 'react';
import { authService } from '../services/authService';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is logged in on mount
    const checkAuth = async () => {
      console.log('[AuthContext] checkAuth called, token exists:', !!token);
      if (token) {
        try {
          console.log('[AuthContext] Calling getCurrentUser...');
          const currentUser = await authService.getCurrentUser();
          console.log('[AuthContext] getCurrentUser success:', currentUser);
          setUser(currentUser);
        } catch (error) {
          // Token is invalid, clear it
          console.error('[AuthContext] getCurrentUser failed:', error);
          console.error('[AuthContext] Error response:', error.response?.status, error.response?.data);
          localStorage.removeItem('token');
          setToken(null);
        }
      }
      setLoading(false);
    };

    checkAuth();
  }, [token]);

  const login = async (username, password) => {
    console.log('[AuthContext] login called for:', username);
    const response = await authService.login(username, password);
    console.log('[AuthContext] login response received, token length:', response.token?.length);
    console.log('[AuthContext] login response user:', response.user);
    localStorage.setItem('token', response.token);
    console.log('[AuthContext] Token saved to localStorage');
    setToken(response.token);
    setUser(response.user);
    console.log('[AuthContext] State updated with token and user');
  };

  const logout = () => {
    setToken(null);
    setUser(null);
    localStorage.removeItem('token');
  };

  const value = {
    user,
    token,
    loading,
    login,
    logout,
    isAuthenticated: !!token,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
